import { Button, MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";

const VatRatesList = ({ history }) => (
  <Main
    page={{
      name: "Stawki VAT",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Stawki VAT",
        },
      ],
      buttons: <Button type="add" text="Dodaj stawkę" path="/vat_rates/new" />,
    }}
  >
    <MainList
      query_key="vat_rates"
      api_path="/vat_rates"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) => history.push(`/vat_rates/${item.id}`)}
      renderItem={({ name, value, country_code }) => (
        <>
          <td>{name}</td>
          <td>{value}%</td>
          <td>{country_code}</td>
        </>
      )}
    />
  </Main>
);

export default VatRatesList;
